import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import { CatalogueMatchDTO, EditionDTO } from "@/dtos/sqe-dtos";

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: "sqe-reference-matcher",
  storage: localStorage
});

export default new Vuex.Store({
  state: {
    scroll_id: 0,
    image_catalog_id: "",
    imageInfo: "",
    imageSide: "",
    edition_catalog_id: 0,
    edition_name: "",
    edition_volume: "",
    edition_location_1: "",
    edition_location_2: "",
    edition_side: "",
    manuscript_name: "",
    matches: [] as CatalogueMatchDTO[],
    col_id: 0,
    colInfo: "",
    user_name: "",
    created_by_name: null as string | null,
    confirmed_by_name: "",
    confirmed: null as boolean | null,
    scrolls: [] as EditionDTO[],
    selectedEdition: {} as EditionDTO,
    session_id: "",
    matchId: 0,
    requestMatchCommitReload: false,
    requestMatchChooserReload: false
  },
  mutations: {
    scroll_idSet(state, val: number) {
      state.scroll_id = val;
    },
    image_catalog_idSet(state, val: string) {
      state.image_catalog_id = val;
    },
    imageInfoSet(state, val: string) {
      state.imageInfo = val;
    },
    imageSideSet(state, val: string) {
      state.imageSide = val;
    },
    edition_catalog_idSet(state, val: number) {
      state.edition_catalog_id = val;
    },
    edition_nameSet(state, val: string) {
      state.edition_name = val;
    },
    edition_volumeSet(state, val: string) {
      state.edition_volume = val;
    },
    edition_location_1Set(state, val: string) {
      state.edition_location_1 = val;
    },
    edition_location_2Set(state, val: string) {
      state.edition_location_2 = val;
    },
    edition_sideSet(state, val: string) {
      state.edition_side = val;
    },
    manuscript_nameSet(state, val: string) {
      state.manuscript_name = val;
    },
    col_idSet(state, val: number) {
      state.col_id = val;
    },
    colInfoSet(state, val: string) {
      state.colInfo = val;
    },
    user_nameSet(state, val: string) {
      state.user_name = val;
    },
    created_by_nameSet(state, val: string | null) {
      state.created_by_name = val;
    },
    confirmed_by_nameSet(state, val: string) {
      state.confirmed_by_name = val;
    },
    confirmedSet(state, val: boolean | null) {
      state.confirmed = val;
    },
    scrollsSet(state, val: EditionDTO[]) {
      state.scrolls = val;
    },
    selectedEditionSet(state, val: EditionDTO) {
      state.selectedEdition = val;
    },
    session_idSet(state, val: string) {
      state.session_id = val;
    },
    matchIdSet(state, val: number) {
      state.matchId = val;
    },
    matchesSet(state, val: CatalogueMatchDTO[]) {
      state.matches = val;
    },
    matchesAdd(state, val: CatalogueMatchDTO) {
      state.matches.push(val);
    },
    matchesUpdate(state, val: [number, CatalogueMatchDTO]) {
      Vue.set(state.matches,
          state.matches.findIndex(x => x.matchId === val[0]),
          val[1]);
    },
    matchesRemove(state, val: number) {
      state.matches.splice(
          state.matches.findIndex(x => x.matchId === val),
          1);
    },
    matchChooserReloadSet(state, val:boolean) {
      state.requestMatchChooserReload = val
    },
    matchCommitReloadSet(state, val: boolean) {
      state.requestMatchCommitReload = val
    }
  },
  actions: {} //,
  //plugins: [vuexPersist.plugin]
});
